import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { ButtonIconText } from '@components/_universal/ButtonIconText/ButtonIconText';
import { Container } from '@components/ions/layouts';

import { maxWidth } from '@utils/helpers';

export const DashboardPageWrapper = styled.div``;

export const ContentWrapper = styled.div(
    ({ theme: { palette } }) => css`
        background-color: ${palette.tertiary.background};
    `,
);

export const DashboardTitle = styled(Typography.TextH1_36_52)`
    ${({ theme: { fontSize, fontWeight } }) => css`
        margin: 0 auto;
        max-width: 790px;
        padding: 52px 0 40px;
        text-align: center;

        ${maxWidth('sm')} {
            font-size: ${fontSize[24]}px;
            font-weight: ${fontWeight.normal};
            line-height: 32px;
            max-width: 520px;
        }
    `}
`;

export const MainContentWrapper = styled.main`
    display: grid;
    gap: 72px;
    grid-template-columns: minmax(0, 1fr) 586px;

    ${maxWidth('lg')} {
        gap: 24px;
    }

    ${maxWidth('md')} {
        display: flex;
        flex-direction: column;
        margin: 0 auto;
        max-width: 790px;
    }
`;

export const PlatformDescription = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    min-width: 0;
    padding-top: 14px;

    ${maxWidth('md')} {
        padding-top: 0;
        gap: 12px;
    }
`;

const BoldText = styled.span(
    ({ theme: { fontWeight } }) => css`
        font-weight: ${fontWeight.bold};
    `,
);

export const ScrollLink = styled(BoldText)(
    ({ theme: { palette } }) => css`
        color: ${palette.tertiary.default};
        cursor: pointer;
        text-transform: lowercase;

        &:hover {
            color: ${palette.tertiary.hover};
        }
    `,
);

export const NicoleImage = styled.div`
    display: flex;
    left: -50px;
    margin-top: auto;
    position: relative;
`;

export const MobileDashboardPageWrapper = styled.div`
    display: grid;
    grid-template-rows: 1fr auto;
    height: auto;
`;

export const MobileContentWrapper = styled.div`
    overflow-y: auto;
`;

export const MobileDashboardTitle = styled(Typography.TextBody_16_24)`
    margin: 32px auto 0;
    max-width: 342px;
    text-align: center;
`;

export const MobileTilesWrapper = styled.div`
    width: 100%;
`;

export const MobileLoginActionsWrapper = styled(Container)(
    ({ theme: { palette } }) => css`
        align-items: center;
        background: ${palette.neutral.white};
        bottom: 0;
        display: flex;
        flex-direction: column;
        gap: 16px;
        left: 0;
        padding-bottom: 0;
        padding-top: 16px;
        position: sticky;
        width: 100%;
        z-index: 9;
    `,
);

export const LoginLink = styled(Link)`
    text-decoration: none;
    width: 100%;
`;

export const ButtonIconTextElement = styled(ButtonIconText)`
    bottom: 132px;
    position: fixed;
    right: 32px;
    z-index: 99;
`;

export const CompanyText = styled(Typography.TextBody_16_24)`
    margin-bottom: 24px;
`;

// Skeletons
export const SkeletonsContentWrapper = styled(MainContentWrapper)`
    padding-bottom: 40px;
`;

export const SkeletonsCompanyPolicies = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 40px 0;
`;

export const SkeletonMobileWrapper = styled(MobileDashboardPageWrapper)``;
